export const DocumentField = (documentType) => {
    switch (documentType) {
        case 'OFFER_LETTER':
            return [
                "employee_name", "offer_date", "joining_date", "monthly_salary", "salary",
                "authorized_signatory_name", "authorized_signatory_designation"
            ];

        case 'RELIEVING_LETTER':
            return [
                "relieving_letter_date", "employee_name", "employee_address", "resignation_date", "joining_date",
                "last_working_date", "designation", "department_name", "authorized_signatory_name",
                "authorized_signatory_designation"
            ];

        case 'EXPERIENCE_LETTER':
            return [
                "experience_letter_date", "employee_name", "joining_date", "first_designation",
                "last_working_date", "last_designation", "number_of_promotion", "authorized_signatory_name",
                "authorized_signatory_designation"
            ];

        case 'APPOINTMENT_LETTER':
            return [
                "employee_name", "appointment_date", "designation", "joining_date", "salary"
            ];

        case 'NURTURE_APPOINTMENT_LETTER':
            return [
                "employee_name", "appointment_date", "designation", "joining_date", "salary"
            ];

        case 'APPRAISAL_LETTER':
            return [
                "appraisal_date", "employee_name", "employee_code", "designation", "effective_date", "current_ctc",
                "revised_ctc", "rating_grade", "authorized_signatory_name", "authorized_signatory_designation"
            ];

        case 'EXTENSION_LETTER':
            return [
                "extension_date", "employee_name", "designation", "department_name", "original_start_date",
                "original_end_date", "number_of_months", "effective_start_date", "effective_end_date",
                "authorized_signatory_name", "authorized_signatory_designation"
            ];

        case 'SECURITY_CHEQUE_DEPOSIT_LETTER':
            return [
                "security_cheque_date", "joining_date", "employee_name", "employee_address", "cheque_date",
                "cheque_no", "bank_name", "account_number"
            ];

        case 'NURTURE_SECURITY_CHEQUE_DEPOSIT_LETTER':
            return [
                "security_cheque_date", "joining_date", "employee_name", "employee_address", "cheque_date",
                "cheque_no", "bank_name", "account_number"
            ];

        case 'EMPLOYMENT_BOND_AGREEMENT_LETTER':
            return [
                "bond_agreement_date", "employee_name", "employee_address", "number_of_months"
            ];

        case 'EMPLOYEE_CONFIRMATION_LETTER':
            return [
                "date", "employee_name", "employee_id", "designation", "confirmation_date",
                "authorized_signatory_name", "authorized_signatory_designation"
            ];

        default:
            return [];
    }
};